/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 1/21/14
 * Time: 10:29 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("content-templates/content-gallery/system/contentSystemTableView.tmpl");
    var ContentSystemTableRowView = require("content-views/content-gallery/system/ContentSystemTableRowView");
    var ContentSystemEmptyTableView = require("content-views/content-gallery/system/ContentSystemEmptyTableView");
    var Checkbox = require("ui/checkbox/Checkbox");
    var Constant = require("content-config/constant.json");

    var TYPES = Constant.CONTENT_TYPES;

    var ContentSystemTableView = {};
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentSystemTableView = Marionette.GridView.extend({
            template : template,
            itemView : ContentSystemTableRowView,
            emptyView: ContentSystemEmptyTableView,
            itemViewContainer : "tbody",
            selectedItem:null,
            className: "table-main ui-table",

            ui:{
                selector:'.selector',
                name:'.name>.value',
                languageContainer:'.languages-container',
                skills: '.skills'
            },

            events : {
                "click .selector" : "checkboxWrapperClick"
            },

            //--------------------------------------------------
            // initialize
            //--------------------------------------------------

            initialize : function (options) {
                 this.channel = options.channel;
                 this.type = options.type;
                 this.listenTo(this.channel,"paging:clear:AllSelection", this._clearSelection);
                 this.isAcUser = options.isAcUser;
            },

            //--------------------------------------------------
            // render
            //--------------------------------------------------

            buildItemView : function (item, ItemView) {
                var view = new ItemView({
                    channel:this.channel,
                    model : item
                });
                return view;
            },

            //---------------------------------------------------

            onRender:function(){
                this.$el.toggleClass("type-" + this.type,true);
            //  this.setCheckAll(); unsupported sever side functionality
                this.showRelevantColumns();
            },

            //---------------------------------------------------
              //unsupported sever side functionality
//            setCheckAll:function(){
//                this.checkAll = new Checkbox({
//                    checked:false,
//                    label:'',
//                    permutation: Checkbox.PERMUTATION.B,
//                    el:this.ui.selector
//                });
//                this.checkAll.render();
//
//                this.ui.selector.on('click',
//                    _.bind(function (ev) {
//                        if ($(ev.target).hasClass('selector')) {
//                            this.checkAll.checkboxClick(ev);
//                        }
//                    },this));
//
//                this.listenTo(this.checkAll, Checkbox.TRIGGERING.CHANGE, this.checkAllItems);
//            },

            //---------------------------------------------------

            showRelevantColumns:function(){
                var table = this.$el.find('table');
                table.addClass("system");
                if (this.isAcUser) {
                    this.ui.skills.removeClass("hide");
                }
            },

            onCompositeCollectionRendered: function () {
                var selectedModels = this.collection.getSelected();

                _.each(selectedModels, function (model) {
                    var rowView = this.children.findByModel(model);
                    if (rowView) {
                        rowView.selectRow(true);
                        this.selectedRowView = rowView;
                    }
                }, this);

            },

            //---------------------------------------------------

            checkAllItems: function(checked){
                this.children.each(function(itemView){

                    if(checked){
                        itemView.selectRow(true);
                        this.collection.addToSelection(itemView.model,{silent:true});
                    }else{
                        itemView.selectRow(false);
                        this.collection.deselectModel(itemView.model,{silent:true});
                    }
                }, this);
            },
            //marrionette search for function name like this on + Itemview + eventname - if it find it it calls it
            onItemviewSelectClicked:function(itemView,checked){
                LEContent.logger.info("Content table: user selected cotnent id: " + itemView.model.get('id'), "ContentSystemTableView:_rowSelectClicked");
                if (this.selectedRowView){  //support only single select   so lets unselect the previous line selected
                    this.selectedRowView.selectRow(false);
                }
                this.selectedRowView = itemView;

                itemView.selectRow(checked);

                this.channel.trigger("contentSystemGalleryTable:selectClicked", {model:itemView.model, select: checked});

            },

            _clearSelection: function () {
//                Clear all the selection that on model that are not on the page/context view.
//                For ex: second page view, Not on current filter view, not on current search result view.
                this.collection.getOriginalCollection().clearSelection();
//                Clear all the selection on the page/context view.
                this.checkAllItems(false);
            }

        });

    });
    return ContentSystemTableView;
});
